/**
 * 代驾端 DidiJSBridge 封装
 * 参考：https://git-hz.xiaojukeji.com/kui/native/tree/master
 * @author linkFly(jianglai@didichuxing.com)
 */


import { ERR_OK } from '../util'


/*
  工作原理：
    访问代驾的私协，代驾会注入 window.WebViewJavascriptBridge， 这就是代驾 bridge
    然后会执行 window.WVJBCallbacks（这是一个回调函数 array）
    然后调用 bridge.callHandler 就可以调用对应方法了
    代驾的回调函数直接就返回了结果，和乘客端不一样（乘客端返回结果是 { errorno, errmsg, result })
*/
let schema = 'wvjbscheme://__BRIDGE_LOADED__',
  loadedFrame = false

function createFrame(src = schema) {
  let frame = document.createElement('IFRAME')
  frame.style.display = 'none'
  frame.src = src
  document.body.appendChild(frame)
  loadedFrame = true
  setTimeout(() => {
    document.body.removeChild(frame)
  }, 100)
}

if (!window.WVJBCallbacks) {
  window.WVJBCallbacks = [];
}

function getBridge() {
  return window.WebViewJavascriptBridge || null;
}

export default (name, params, callback) => {
  var bridge = getBridge()
  var cb = function (_bridge) {
    _bridge.callHandler(name, params, callback)
  }
  if (bridge) {
    cb(bridge)
  } else {
    window.WVJBCallbacks.push(cb)
    // 如果还没有访问过私协，则立即访问
    if (!loadedFrame) {
      createFrame()
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/epower/bridge/ddbridgedaijiadriver/ios.js